import { TProcessingResult } from '@ws/shared/types';

import { ResultFormatter } from './ResultFormatter';

export abstract class Validator<T> extends ResultFormatter<T> {
  public validate(value: T): TProcessingResult<T> {
    return this.createSuccessResponse(value);
  }
}
